import managedKeysEnum from './managedKeysEnum'

const NotificationTypesEnum = Object.freeze({
  email: managedKeysEnum.EMAIL,
  notification: managedKeysEnum.NOTIFICATION,
})

export default NotificationTypesEnum
